/**
 * What a playEngine export can be built for.
 *
 * The network names are the keys the server validates against (the `networks`
 * map in controller/versionPlayEngine/preBuildPlayEngine.js) and the loading
 * screens are the engine's `--env loadingScreen` values. Both the version
 * editor's export dialog and the snapshot editor's read them from here so
 * a network added in one place shows up in the other.
 */

import applovinLogo from "../../images/network/IconsThin/applovin-icon.png";
import facebookLogo from "../../images/network/IconsThin/facebook-icon.png";
import googleLogo from "../../images/network/IconsThin/googleads-icon.png";
import ironsourceLogo from "../../images/network/IconsThin/ironsource-icon.png";
import mintegralLogo from "../../images/network/IconsThin/mintegral-icon.png";
import unityLogo from "../../images/network/IconsThin/unityads-icon.png";
import vungleLogo from "../../images/network/IconsThin/vungle-icon.png";
import tiktokLogo from "../../images/network/IconsThin/tiktok-icon.png";
import molocoIcon from "../../images/network/IconsThin/moloco-icon.png";
import appgrowthIcon from "../../images/network/IconsThin/appgrowth-icon.png";

export const loadingScreenViews = [
  { id: "blankLoading", caption: "Blank Loading" },
  { id: "playinLoading", caption: "Playin Loading" },
];

export const networkViews = [
  { name: "applovin", logo: applovinLogo, caption: "AppLovin" },
  { name: "facebook", logo: facebookLogo, caption: "Facebook" },
  { name: "google", logo: googleLogo, caption: "Google" },
  { name: "ironsource", logo: ironsourceLogo, caption: "IronSource" },
  { name: "mintegral", logo: mintegralLogo, caption: "Mintegral" },
  { name: "unity", logo: unityLogo, caption: "Unity" },
  { name: "liftoff", logo: vungleLogo, caption: "Liftoff" },
  { name: "tiktok", logo: tiktokLogo, caption: "Tiktok" },
  { name: "moloco", logo: molocoIcon, caption: "Moloco" },
  { name: "appgrowth", logo: appgrowthIcon, caption: "AppGrowth" },
];

/** Display name for a network key, falling back to the key itself. */
export function networkCaption(name) {
  const view = networkViews.find((item) => item.name === name);
  return view ? view.caption : name;
}
